import { DataBean } from "../../../DataBean";



export class HealthServiceProvision extends DataBean {


    public async getHealthServiceProvisionCatalog(idAccount:any,idClinicalDocument:any,issueDate:any,technologyType:any,idLn:any,idHealthMedication:any,idMedicalDevice:any,idBodyComponent:any,idHealthProduct:any,idHealthTechnologyPurpose:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getHealthServiceProvisionCatalog_Number_Number_java.util.Date_Number_Number_Number_Number_Number_Number_Number_Number_Number", [idAccount,idClinicalDocument,issueDate,technologyType,idLn,idHealthMedication,idMedicalDevice,idBodyComponent,idHealthProduct,idHealthTechnologyPurpose,page,recordsPerPage]);
    }
 public async addHealthServiceProvision(idClinicalDocument:any,issueDate:any,technologyType:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.health.HealthServiceProvision_addHealthServiceProvision_Number_java.util.Date_Number_Number", [idClinicalDocument,issueDate,technologyType,idEmployee]);
    }

}